import React from "react"
import { Button } from "@chakra-ui/react"
import { FaRegMinusSquare, FaRegPlusSquare } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import { ChatStyles } from "src/components/servicesPanel/chat"

const ChatStatus = window.MeetOnline.ChatStatus

type Props = {
  isApproved: boolean
  chatApprovalRequired: boolean
  isAuthorModerator: boolean
  widthButton: string
  toggleChatApprove: (isApproved: boolean) => void
  styleschat: ChatStyles
  displaySmall?: boolean
}

const ApproveUnapproveButton = (props: Props) => {
  const {
    isApproved,
    chatApprovalRequired,
    isAuthorModerator,
    widthButton,
    toggleChatApprove,
    styleschat,
    displaySmall
  } = props
  const { t } = useTranslation()

  if (!((chatApprovalRequired === true || !isApproved) && !isAuthorModerator))
    return null

  return (
    <Button
      leftIcon={isApproved ? <FaRegMinusSquare /> : <FaRegPlusSquare />}
      iconSpacing={displaySmall ? ".25rem" : undefined}
      type="button"
      isApproved={isApproved}
      width={widthButton ?? "96px"}
      wordBreak="normal"
      color="#1A202C"
      onClick={e => {
        toggleChatApprove(
          isApproved ? ChatStatus.REJECTED : ChatStatus.APPROVED
        )
      }}
      fontWeight={"bold"}
      bg={styleschat?.secondaryAccessButtonBackgroundColor ?? "#1AC541"}
      border={
        styleschat?.secondaryAccessButtonBorderColor
          ? `1px solid ${
              styleschat?.secondaryAccessButtonBorderColor
                ? styleschat.secondaryAccessButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={styleschat?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          styleschat?.secondaryAccessButtonMouseoverColor ?? "#24A840",
        textColor:
          styleschat?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
      }}
      _focus={{}}
      zIndex="10000"
      whiteSpace="pre-wrap"
      minWidth={displaySmall ? "unset" : widthButton ?? "96px"}
      padding={displaySmall ? ".65rem" : undefined}
      height={displaySmall ? "unset" : undefined}
      fontSize={
        displaySmall
          ? "0.6rem"
          : isApproved
          ? t("Unapprove").length > 9
            ? "0.6rem"
            : "0.75rem"
          : t("Approve").length > 7
          ? "0.6rem"
          : "0.75rem"
      }
    >
      {isApproved ? t("Unapprove") : t("Approve")}
    </Button>
  )
}

export default ApproveUnapproveButton
